import React from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import POS from "@/pages/POS";
import OnlineOrders from "@/pages/OnlineOrders";
import Inventory from "@/pages/Inventory";
import Purchases from "@/pages/Purchases";
import Users from "@/pages/Users";
import Reports from "@/pages/Reports";
import Audit from "@/pages/Audit";
import Admin from "@/pages/Admin";
import PublicOrder from "@/pages/PublicOrder";
import AuthCallback from "@/pages/AuthCallback";

const defaultRouteFor = (user) => {
  const p = user?.permissions || [];
  if (p.includes("ventas")) return "/pos";
  if (p.includes("pedidos")) return "/pedidos-online";
  if (p.includes("inventario")) return "/inventario";
  if (p.includes("reportes")) return "/reportes";
  return "/pos";
};

function Guard({ module, children }) {
  const { user, can } = useAuth();
  if (user === null) return <div className="min-h-screen flex items-center justify-center bg-background text-muted-foreground">Cargando…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (module && !can(module)) return <Navigate to={defaultRouteFor(user)} replace />;
  return <Layout>{children}</Layout>;
}

function Root() {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen flex items-center justify-center bg-background text-muted-foreground">Cargando…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={defaultRouteFor(user)} replace />;
}

function AppRoutes() {
  const loc = useLocation();
  if (loc.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/pedidos" element={<PublicOrder />} />
      <Route path="/" element={<Root />} />
      <Route path="/pos" element={<Guard module="ventas"><POS /></Guard>} />
      <Route path="/pedidos-online" element={<Guard module="pedidos"><OnlineOrders /></Guard>} />
      <Route path="/inventario" element={<Guard module="inventario"><Inventory /></Guard>} />
      <Route path="/compras" element={<Guard module="compras"><Purchases /></Guard>} />
      <Route path="/usuarios" element={<Guard module="usuarios"><Users /></Guard>} />
      <Route path="/reportes" element={<Guard module="reportes"><Reports /></Guard>} />
      <Route path="/auditoria" element={<Guard module="auditoria"><Audit /></Guard>} />
      <Route path="/administracion" element={<Guard module="administracion"><Admin /></Guard>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors theme="dark" />
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}
